import { SxProps, Theme } from '@mui/material/styles';

export const checkboxSx: SxProps<Theme> = {};
